<funding-modal
	#fundingModalComponent
	[showModal]="showFundingModal"
></funding-modal>
<deal-modal #dealModalComponent [showModal]="showDealModal"></deal-modal>
<div class="info">
	<p>
		{{ Loc(LocalizedTextIds.JnjInformationItsImportant) }}
	</p>
</div>
<edit-item-group [propertyGroup]="miscProperties" [parentForm]="parentForm">
</edit-item-group>
@if(featureSwitches.companyUpdateSwitches.enableDeals){
<div class="info-section-header" [ngClass]="{ pending: haveDealsChanged }">
	{{ Loc(LocalizedTextIds.CompanyDetailsDeals) }}
	@if(selfUpdateMode === SelfUpdateModes.Edit) {
	<div class="add-edit-review-button" (click)="openDeal()">
		+{{ Loc(LocalizedTextIds.Add) }}
	</div>
	}
</div>
@if(company.deals?.length > 0) {
<table class="deals-funding-table">
	<tr>
		<th class="deal-party-column">
			{{ Loc(LocalizedTextIds.DealModalDealParty) }}
		</th>
		<th class="currencycolumn">
			{{ Loc(LocalizedTextIds.CompanyDetailsAmount) }}
		</th>
		<th class="datecolumn">
			{{ Loc(LocalizedTextIds.CompanyDetailsAnnouced) }}
		</th>
		<th class="typecolumn">
			{{ Loc(LocalizedTextIds.CompanyDetailsType) }}
		</th>
		<th class="publicly-shared-column">
			{{ Loc(LocalizedTextIds.JnjInformationPubliclyShared) }}
		</th>
		<th class="editcolumn">&nbsp;</th>
	</tr>
	@for(deal of company.deals; track deal.dealId) {
	<tr>
		<td class="deal deal-party-column">
			<div [ngClass]="{ strikethrough: deal.isDeleted }">
				{{ deal.dealParty }}
			</div>
			@if(isAdded(deal, 'dealId')) {
			<div class="added">
				{{ Loc(LocalizedTextIds.Added) }}
			</div>
			} @if(isApproved(deal, 'dealId')) {
			<div class="added">
				{{ Loc(LocalizedTextIds.Approved) }}
			</div>
			} @if(deal.isDeleted) {
			<div class="deleted">
				{{ Loc(LocalizedTextIds.Deleted) }}
			</div>
			} @if(selfUpdateMode === SelfUpdateModes.Edit &&
			updateForReview.dealUpdates[deal.dealId]) {
			<div class="modified-flag"></div>
			}
			<review-deal-funding
				[hidden]="
					selfUpdateMode !== SelfUpdateModes.Review ||
					!updateForReview.dealUpdates[deal.dealId]
				"
				[item]="deal"
			>
			</review-deal-funding>
		</td>
		<td class="currencycolumn">
			<div class="dealamounts">
				@if(deal.amount) {
				<div class="deal">
					<div
						class="header"
						[ngClass]="{ strikethrough: deal.isDeleted }"
					>
						{{ Loc(LocalizedTextIds.Secured) }}
					</div>
					@if(IsNumberOrNumberString(deal.amount)){
					<div [ngClass]="{ strikethrough: deal.isDeleted }">
						{{
							deal.amount
								| currency
									: deal.amountCurrency
									: 'symbol-narrow'
									: '1.0-0'
						}}
						{{ deal.amountCurrency }}
					</div>
					} @else {
					<span [ngClass]="{ strikethrough: deal.isDeleted }">
						{{ deal.amount }}</span
					>
					}
				</div>
				} @if(deal.contingentAmount) {
				<div class="deal">
					<div
						class="header"
						[ngClass]="{ strikethrough: deal.isDeleted }"
					>
						{{ Loc(LocalizedTextIds.Contingent) }}
					</div>
					@if(IsNumberOrNumberString(deal.contingentAmount)) {
					<div [ngClass]="{ strikethrough: deal.isDeleted }">
						{{
							deal.contingentAmount
								| currency
									: deal.amountCurrency
									: 'symbol-narrow'
									: '1.0-0'
						}}
						{{ deal.amountCurrency }}
					</div>
					} @else {
					<span [ngClass]="{ strikethrough: deal.isDeleted }">{{
						deal.contingentAmount
					}}</span
					>}
				</div>
				}
			</div>
		</td>
		<td class="deal datecolumn">
			<span [ngClass]="{ strikethrough: deal.isDeleted }">{{
				deal.announcementDate | date : 'mediumDate' : 'GMT'
			}}</span>
		</td>
		<td class="deal typecolumn">
			<span [ngClass]="{ strikethrough: deal.isDeleted }">{{
				deal.dealType
			}}</span>
		</td>
		<td class="publicly-shared-column deal">
			<div>
				<div class="value">
					{{
						deal.isConfidential
							? Loc(LocalizedTextIds.No)
							: Loc(LocalizedTextIds.Yes)
					}}
				</div>
				@if(selfUpdateMode === SelfUpdateModes.Review &&
				updateForReview.dealUpdates[deal.dealId]) {
				<approve-decline
					[deal]="deal"
					[includeInSummary]="
						updateForReview.dealUpdates[deal.dealId]
					"
				>
				</approve-decline>
				}
			</div>
		</td>
		<td class="editcolumn">
			@if(selfUpdateMode === SelfUpdateModes.Edit ||
			updateForReview.dealUpdates[deal.dealId]) {
			<div (click)="openDeal(deal)">
				<div class="add-edit-review-button">
					+{{
						selfUpdateMode === SelfUpdateModes.Edit
							? Loc(LocalizedTextIds.Edit)
							: Loc(LocalizedTextIds.Review)
					}}
				</div>
			</div>
			}
		</td>
	</tr>
	}
</table>
} }
<div class="section-spacer"></div>
<div class="info-section-header" [ngClass]="{ pending: haveFundingsChanged }">
	{{ Loc(LocalizedTextIds.Funding) }}
	@if(selfUpdateMode === SelfUpdateModes.Edit) {
	<div class="add-edit-review-button" (click)="openFunding()">
		+{{ Loc(LocalizedTextIds.Add) }}
	</div>
	}
</div>

@if(company.funding?.length > 0) {
<table class="deals-funding-table">
	<tr>
		<th class="roundcolumn">
			{{ Loc(LocalizedTextIds.CompanyDetailsFundingRound) }}
		</th>
		<th class="currencycolumn">
			{{ Loc(LocalizedTextIds.CompanyDetailsAmount) }}
		</th>
		<th class="datecolumn">
			{{ Loc(LocalizedTextIds.CompanyDetailsDateRaised) }}
		</th>
		<th class="funding-party-column">
			{{ Loc(LocalizedTextIds.CompanyDetailsFundingParty) }}
		</th>
		<th class="publicly-shared-column">
			{{ Loc(LocalizedTextIds.JnjInformationPubliclyShared) }}
		</th>
		<th class="editcolumn">&nbsp;</th>
	</tr>
	@for(item of company.funding; track item.fundingId) {
	<tr>
		<td class="funding roundcolumn">
			<div [ngClass]="{ strikethrough: item.isDeleted }">
				{{ item.fundingRound }}
			</div>
			@if(isAdded(item, 'fundingId')){
			<div class="added">
				{{ Loc(LocalizedTextIds.Added) }}
			</div>
			} @if(isApproved(item, 'fundingId')){
			<div class="added">
				{{ Loc(LocalizedTextIds.Approved) }}
			</div>
			} @if(item.isDeleted) {
			<div class="deleted">
				{{ Loc(LocalizedTextIds.Deleted) }}
			</div>
			} @if(selfUpdateMode === SelfUpdateModes.Edit &&
			updateForReview.fundingUpdates[item.fundingId]){
			<div class="modified-flag"></div>
			}
			<review-deal-funding
				[hidden]="
					selfUpdateMode !== SelfUpdateModes.Review ||
					!updateForReview.fundingUpdates[item.fundingId]
				"
				[item]="item"
			>
			</review-deal-funding>
		</td>
		<td class="currencycolumn">
			@if(IsNumberOrNumberString(item.raised)){
			<div [ngClass]="{ strikethrough: item.isDeleted }">
				{{
					item.raised
						| currency
							: item.raisedCurrency
							: 'symbol-narrow'
							: '1.0-0'
				}}
				{{ item.raisedCurrency }}
			</div>
			}@else {
			<span [ngClass]="{ strikethrough: item.isDeleted }">{{
				item.raised
			}}</span
			>}
		</td>
		<td class="datecolumn" [ngClass]="{ strikethrough: item.isDeleted }">
			{{ item.dateRaised | date : 'mediumDate' : 'GMT' }}
		</td>
		<td
			class="funding-party-column"
			[ngClass]="{ strikethrough: item.isDeleted }"
		>
			{{ item.fundingParty }}
		</td>
		<td class="publicly-shared-column">
			<div>
				<div class="value">
					{{
						item.isConfidential
							? Loc(LocalizedTextIds.No)
							: Loc(LocalizedTextIds.Yes)
					}}
				</div>
				@if(selfUpdateMode === SelfUpdateModes.Review &&
				updateForReview.fundingUpdates[item.fundingId]) {
				<approve-decline
					[funding]="item"
					[includeInSummary]="
						updateForReview.fundingUpdates[item.fundingId]
					"
				>
				</approve-decline>
				}
			</div>
		</td>
		<td class="editcolumn">
			@if(selfUpdateMode === SelfUpdateModes.Edit ||
			updateForReview.fundingUpdates[item.fundingId]){
			<div (click)="openFunding(item)">
				@if(selfUpdateMode === SelfUpdateModes.Edit){
				<div class="add-edit-review-button">
					+{{ Loc(LocalizedTextIds.Edit) }}
				</div>
				} @if(selfUpdateMode === SelfUpdateModes.Review){
				<div class="add-edit-review-button">
					+{{ Loc(LocalizedTextIds.Review) }}
				</div>
				}
			</div>
			}
		</td>
	</tr>
	}
</table>
}

<div class="section-spacer"></div>
@if(enableDiversityQuestions) {
<edit-item-group [propertyGroup]="deiProperties" [parentForm]="parentForm">
</edit-item-group>
}
